const Whatsapp = ({ type }) => {
  const regular = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-0.00012207 20L1.40571 14.8642C0.53821 13.3608 0.0823778 11.6567 0.0832111 9.90917C0.0857111 4.44583 4.53153 0 9.99402 0C12.6448 0.000833333 15.1332 1.03333 17.0048 2.90667C18.8757 4.78 19.9057 7.27 19.9048 9.91833C19.9023 15.3825 15.4565 19.8283 9.99402 19.8283C8.33569 19.8275 6.70153 19.4117 5.25403 18.6217L-0.00012207 20ZM5.49737 16.8275C6.89403 17.6567 8.22736 18.1533 9.99069 18.1542C14.5307 18.1542 18.229 14.4592 18.2315 9.91667C18.2332 5.365 14.5523 1.675 9.99736 1.67333C5.45403 1.67333 1.75821 5.36833 1.75654 9.91C1.75571 11.7642 2.29904 13.1525 3.21154 14.605L2.37904 17.645L5.49737 16.8275ZM14.9865 12.2742C14.9248 12.1708 14.7598 12.1092 14.5115 11.985C14.264 11.8608 13.0465 11.2617 12.819 11.1792C12.5923 11.0967 12.4274 11.055 12.2615 11.3033C12.0965 11.5508 11.6215 12.1092 11.4774 12.2742C11.3332 12.4392 11.1882 12.46 10.9407 12.3358C10.6932 12.2117 9.89486 11.9508 8.94902 11.1067C8.21319 10.45 7.71569 9.63917 7.57153 9.39083C7.42736 9.14333 7.55653 9.00917 7.67986 8.88583C7.79153 8.775 7.92736 8.59667 8.05153 8.45167C8.17736 8.30833 8.21819 8.205 8.30153 8.03917C8.38403 7.87417 8.34319 7.72917 8.28069 7.605C8.21819 7.48167 7.72319 6.2625 7.51736 5.76667C7.31569 5.28417 7.11153 5.34917 6.95986 5.34167L6.48486 5.33333C6.31986 5.33333 6.05153 5.395 5.82486 5.64333C5.5982 5.89167 4.9582 6.49 4.9582 7.70917C4.9582 8.92833 5.8457 10.1058 5.96903 10.2708C6.0932 10.4358 7.71486 12.9375 10.199 14.01C10.7899 14.265 11.2515 14.4175 11.6107 14.5317C12.204 14.72 12.744 14.6933 13.1707 14.63C13.6465 14.5592 14.6357 14.0308 14.8423 13.4525C15.049 12.8733 15.049 12.3775 14.9865 12.2742Z"
        fill="black"
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Whatsapp;
